import { useEffect, useState } from 'react';

let cache = null;

export function useProtectedProjects() {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/protected-projects`)
      .then((r) => r.json())
      .then((d) => {
        cache = d.projects || [];
        setList(cache);
      })
      .catch(() => {});
  }, []);
  return list;
}

export function isUnlocked() {
  return sessionStorage.getItem('dg-projects-unlocked') === '1';
}

export function markUnlocked() {
  sessionStorage.setItem('dg-projects-unlocked', '1');
}
